import { Service } from "typedi";
import { AgentRPCCommand } from "../../../../shared/RPC/AgentRPCCommand";
import { AgentRPCCommands } from "../../../../shared/RPC/AgentRPCCommands";
import { ControllerBroadcaster } from "../ControllerBroadcaster";

/**
 * v1 `push.tab`: we cannot open a new tab without `chrome.tabs`. Best-effort
 * fallback — tell every content script to `navigate` there. In practice the
 * leader can choose a single focused content script when focus tracking
 * lands; for now, "push to all" is a safe approximation for kiosk-style
 * classrooms.
 */
@Service()
export class PushTab implements AgentRPCCommand<"push.tab"> {
    constructor(
        agentRPCCommands: AgentRPCCommands,
        private readonly broadcaster: ControllerBroadcaster
    ) {
        agentRPCCommands.register("push.tab", this);
    }

    async run(url: string): Promise<void> {
        this.broadcaster.broadcastToContentScripts({ kind: "navigate", url });
    }
}
